import type { Suit } from '@/lib/bridge/protocol';

export const SUIT_GLYPH: Record<Suit, string> = { S: '♠', H: '♥', D: '♦', C: '♣' };

/** Cuori e quadri si leggono in rosso (il token `danger` della TMA); picche e fiori nel colore del testo. */
export const isRedSuit = (suit: Suit): boolean => suit === 'H' || suit === 'D';

// I COLORI DEI SEMI (K9a, reference R1 «regole per tutte le tavole» 3). Non sono token del tema: una carta deve restare leggibile
// identica in ogni tema (come le carte del Burraco). A DUE colori ♠♣ nero e ♥♦ rosso; a QUATTRO (opzione di chi gioca) ♦ arancio e ♣ verde.
const SULLA_CARTA_2: Record<Suit, string> = { S: '#1a2322', C: '#1a2322', H: '#c62828', D: '#c62828' };
const SULLA_CARTA_4: Record<Suit, string> = { S: '#1a2322', H: '#c62828', D: '#b35300', C: '#1b7a3d' };
// Su fondo scuro il rosso del token `danger` (#d8403d) sul teal non si legge: ♥♦ `#ff6b66`, come negli scacchi.
const SUL_FONDO_2: Record<Suit, string> = { S: '#e6f4f2', C: '#e6f4f2', H: '#ff6b66', D: '#ff6b66' };
const SUL_FONDO_4: Record<Suit, string> = { S: '#e6f4f2', H: '#ff6b66', D: '#ffa04d', C: '#5fd08a' };

/** Il colore del seme su una CARTA bianca. */
export const inchiostroSullaCarta = (suit: Suit, quattroColori: boolean): string =>
  (quattroColori ? SULLA_CARTA_4 : SULLA_CARTA_2)[suit];

/** Il colore del seme su FONDO SCURO (testo del coach, glifi accanto alle carte). */
export const inchiostroSulFondo = (suit: Suit, quattroColori: boolean): string =>
  (quattroColori ? SUL_FONDO_4 : SUL_FONDO_2)[suit];
